<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form__section-header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row form__row form__row--personal">
            <div :class="['col-12', {'col-md-6':limitPersonalData()}]">
                <span v-for="field in fields.personalInformation[0]" :key="field">
                    <div v-if="limitPersonalData() || field !== 'title'" :class="['form-field',{'form-field--error':$v.formData.personalInformation[field].$error}]">
                        <label :for="field">{{ formLabels.fields[field] }} <span v-if="smallText[field]">- {{smallText[field]}}</span></label>
                        <date-picker v-if="field == 'dob'" v-model="formData.personalInformation[field]" :id="field" format="DD/MM/YYYY" value-type="format"></date-picker>
                        <input v-else v-model="formData.personalInformation[field]" :id="field" type="text" />
                        <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personalInformation && formTooltips.personalInformation.fields[field]" v-tooltip="formTooltips.personalInformation.fields[field]">?</span>
                        <span class="form-field__error" v-if="$v.formData.personalInformation[field].$error && !$v.formData.personalInformation[field].required">This field is required</span>
                        <span class="form-field__error" v-else-if="$v.formData.personalInformation[field].$error && !$v.formData.personalInformation[field].checkEmailDomain">This field requires a valid NTU email address</span>
                        <span class="form-field__error" v-else-if="$v.formData.personalInformation[field].$error">This field is invalid</span>
                    </div>
                </span>
            </div>
            <div class="col-12 col-md-6" v-if="limitPersonalData()">
                <span v-for="field in fields.personalInformation[1]" :key="field">
                    <div  :class="['form-field',{'form-field--error':$v.formData.personalInformation[field].$error}]">
                        <label :for="field">{{ formLabels.fields[field] }} <span v-if="smallText[field]">- {{smallText[field]}}</span></label>
                        <input v-model="formData.personalInformation[field]" :id="field" type="text" />
                        <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personalInformation && formTooltips.personalInformation.fields[field]" v-tooltip="formTooltips.personalInformation.fields[field]">?</span>
                        <span class="form-field__error" v-if="$v.formData.personalInformation[field].$error && !$v.formData.personalInformation[field].required">This field is required</span>
                        <span class="form-field__error" v-else-if="$v.formData.personalInformation[field].$error && !$v.formData.personalInformation[field].checkEmailDomain">This field requires a valid NTU email address</span>
                        <span class="form-field__error" v-else-if="$v.formData.personalInformation[field].$error">This field is invalid</span>
                    </div>
                </span>
            </div>
        </div>
        <hr />
        <div v-if="limitPersonalData()" class="row form__row form__row--employee">
            <div class="col-12" v-if="($v.formData.personalInformation.employeeNumber.$error && !$v.formData.personalInformation.employeeNumber.required) && ($v.formData.personalInformation.niNumber.$error && !$v.formData.personalInformation.niNumber.required)">
                <div class="form-field">
                    <p class="form-field__error">You must supply either your Employee Number or National Insurance number</p>
                </div>
            </div>
            <div v-for="field in fields.employeeDetails" :key="field" class="col-12 col-md-6">
                <div :class="['form-field',{'form-field--error':$v.formData.personalInformation[field].$error}]">
                    <label :for="field">{{ formLabels.fields[field] }} <span v-if="smallText[field]">- {{smallText[field]}}</span></label>
                    <input v-model="formData.personalInformation[field]" :id="field" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personalInformation && formTooltips.personalInformation.fields[field]" v-tooltip="formTooltips.personalInformation.fields[field]">?</span>
                    <span class="form-field__error" v-if="$v.formData.personalInformation[field].$error && !$v.formData.personalInformation[field].required">This field is required</span>
                    <span class="form-field__error" v-else-if="$v.formData.personalInformation[field].$error">This field is invalid</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { required, requiredIf, sameAs, minLength, maxLength } from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';

export default {
    data: () => ({
        fields: {
            personalInformation: [['title', 'firstName', 'lastName', 'emailAddress'], ['streetAddress', 'townCity', 'postcode']],
            employeeDetails: ['employeeNumber', 'niNumber', 'jobTitle', 'department', 'grade']
        },
        smallText: {
            streetAddress: '(with house name / number)',
            employeeNumber: '(7 digits)',
            emailAddress: '(NTU address only)'
        }
    }),
    computed: {
        ...mapGetters(['formData','formSummary']),
    },
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object,
        },
        formName: {
            type: String
        }
    },
    components: { DatePicker },
    inject: ['$v'],
    watch: {
        'formData.personalInformation': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        }
    },
    methods: {
        buildSummary(fieldData) {
            let fields = {};

            for(let key of Object.keys(fieldData)) {
                fields[this.formLabels.fields[key]] = fieldData[key];
            }

            this.formSummary[0] = {
                title: this.formLabels.title,
                fields: fields
            };
        },
        //Only show necessary fields
        limitPersonalData() {
            
            return this.formName !== 'HealthShieldCashPlan';
        }
    },
    mounted() {
        this.formSummary.push({});
    }
}
</script>